import { getCurrentDetail, redirect } from '$router/config'
import { useCallback } from 'react'

type Value$1 = string | number | bigint | boolean | undefined
type Data$1 = {
  [key: string]: Value$1
}

export const useShallowQueryParams = () => {
  const updateShallowQueryParams = useCallback((queryParams: Data$1) => {
    const routeName = getCurrentDetail()?.name

    if (!routeName) return

    redirect(routeName, options => ({
      ...options,
      queryParams: { ...options.queryParams, ...queryParams },
      replace: true
    }))
  }, [])

  return {
    updateShallowQueryParams
  }
}
